import type { TOC } from '@ember/component/template-only';

import SkeletonScreenComponent from 'webapp/components/skeleton-screen';

const MetricLibraryLoadingRouteTemplate: TOC<object> = <template>
	<SkeletonScreenComponent @type="table" />
</template>;

export default MetricLibraryLoadingRouteTemplate;
